import { isBrowser } from 'fronton-react/utils';

export const isTouchScreen = (): boolean =>
  isBrowser()
    ? 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    : false;
